import { swalError, swalSuccess } from "../../../helpers/swal";
import * as requestFromServer from "./employeeRequest";
import { callTypes, employeeSlice } from "./employeeSlice";

const { actions } = employeeSlice;

export const getAllEmployee = (payload) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAllEmployeeList(payload)
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;
        dispatch(
          actions.allEmployeeFetched({
            totalCount: data.totalItems,
            entities: data.hrms_employee,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
export const getEmployee = (id) => (dispatch) => {
  if (!id) {
    dispatch(
      actions.employeeProfileFetched({
        employeeProfile: null,
      })
    );
    return;
  }
  if (id) {
    dispatch(actions.startCall({ callType: callTypes.action }));
    return requestFromServer
      .getEmployeeProfile(id)
      .then((response) => {
        if (response.data.success) {
          const { data } = response.data;
          dispatch(
            actions.employeeProfileFetched({
              employeeProfile: data,
            })
          );
        } else {
          if (response.data.message) {
            swalError(response.data.message);
          } else {
          }
        }
      })
      .catch((error) => {
        dispatch(actions.catchError({ error, callType: callTypes.action }));
      });
  }
};

export const getEmployeeCurrentUnit = (id) => (dispatch) => {
  if (!id) {
    dispatch(
      actions.employeeProfileUnitFetched({
        unit: null,
      })
    );
    return;
  }
  if (id) {
    dispatch(actions.startCall({ callType: callTypes.action }));
    return requestFromServer
      .getEmployeeUnit(id)
      .then((response) => {
        if (response.data.success) {
          const { data } = response.data;
          dispatch(
            actions.employeeProfileUnitFetched({
              unit: data,
            })
          );
        } else {
          if (response.data.message) {
            swalError(response.data.message);
          } else {
          }
        }
      })
      .catch((error) => {
        dispatch(actions.catchError({ error, callType: callTypes.action }));
      });
  }
};

export const getEmployeeTransfer = (id) => (dispatch) => {
  if (!id) {
    dispatch(
      actions.employeeProfileTransferFetched({
        transfer: null,
      })
    );
    return;
  }
  if (id) {
    dispatch(actions.startCall({ callType: callTypes.action }));
    return requestFromServer
      .getEmployeeTransfer(id)
      .then((response) => {
        if (response.data.success) {
          const { data } = response.data;
          dispatch(
            actions.employeeProfileTransferFetched({
              transfer: data?.data,
            })
          );
        } else {
          if (response.data.message) {
            swalError(response.data.message);
          } else {
          }
        }
      })
      .catch((error) => {
        dispatch(actions.catchError({ error, callType: callTypes.action }));
      });
  }
};
export const getSupervisorList = (id) => (dispatch) => {
  if (id) {
    dispatch(actions.startCall({ callType: callTypes.action }));
    return requestFromServer
      .getSupervisorList(id)
      .then((response) => {
        if (response.data.success) {
          const { data } = response?.data;
          dispatch(
            actions.supervisorListFetched({
              supervisorList: data?.hrms_employee,
            })
          );
        } else {
          if (response.data.message) {
            swalError(response.data.message);
          } else {
          }
        }
      })
      .catch((error) => {
        dispatch(actions.catchError({ error, callType: callTypes.action }));
      });
  }
};

export const getOneSupervisorAssign = (id) => (dispatch) => {
  if (id) {
    dispatch(actions.startCall({ callType: callTypes.action }));
    return requestFromServer
      .getOneSupervisorAssign(id)
      .then((response) => {
        if (response.data.success) {
          const { data } = response?.data;
          const responses = data || [];
          const employee_ids = responses.map((item) => item?.employee_id);
          const employees = responses.map((item) => item?.m_hrms_employee);

          dispatch(
            actions.supervisorOneFetched({
              supervisorAssign: {
                employee_ids: employee_ids,
                employees: employees,
                pre_supervisor_id:
                  responses?.length > 0 && responses[0]?.pre_supervisor_id,
                supervisor_id:
                  responses?.length > 0 && responses[0]?.supervisor_id,
                effective_date:
                  responses?.length > 0 && responses[0]?.effective_date,
                supervisor: responses?.length > 0 && responses[0]?.supervisor,
                pre_supervisor:
                  responses?.length > 0 && responses[0]?.pre_supervisor,
              },
            })
          );
        } else {
          if (response.data.message) {
            swalError(response.data.message);
          } else {
          }
        }
      })
      .catch((error) => {
        dispatch(actions.catchError({ error, callType: callTypes.action }));
      });
  }
};

export const removeEmployee = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return dispatch(
    actions.employeeDeleted({
      id: id,
    })
  );
};

export const getDocumentByEmployeeId = (employeeId) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getDocumentByEmployeeId(employeeId)
    .then((response) => {
      if (response.data.success) {
        const { data } = response?.data;
        dispatch(
          actions.employeeDocumentListFetched({
            employeeDocumentList: data,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getDocumentByDesigCategory = (params) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getDocumentByDesigCategory(params)
    .then((response) => {
      if (response.data.success) {
        const { data } = response?.data;
        dispatch(
          actions.documentListFetched({
            documentList: data?.data,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getEmployeeAllCategoriesList = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getEmployeeCategoriesList()
    .then((response) => {
      if (response.data.success) {
        const { data } = response?.data;
        dispatch(
          actions.allCategoriesListFetched({
            employeeCategoriesList: data?.hrms_employee_categories,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getEmployeeAllGradeList = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getEmployeeGradeList()
    .then((response) => {
      if (response.data.success) {
        const { data } = response?.data;
        dispatch(
          actions.allGradeListFetched({
            gradeList: data?.hrms_grade,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAcademicRankList = (position_category) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAcademicRanks(position_category)
    .then((response) => {
      if (response.data.success) {
        const { data } = response?.data;
        console.log(data);
        const formatedData = data?.map((item) => {
          return {
            label: item?.institute_rank,
            value: item?.id,
          };
        });
        dispatch(
          actions.allAcademicRanks({
            ranks: formatedData,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllTrainingByEmployee = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getTrainingList(id)
    .then((response) => {
      if (response.data.success) {
        console.log(response?.data?.data);
        dispatch(
          actions.allTrainingFetched({
            trainingList: response.data.data.hrms_training,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
export const getAllCertificationsByEmployee = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getCertificationsList(id)
    .then((response) => {
      if (response.data.success) {
        console.log(response?.data?.data);
        dispatch(
          actions.allCertificationsFetched({
            certificationList:
              response.data.data.hrms_professional_certification,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
export const getAllEducationForEmployee = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getEducationForEmployee(id)
    .then((response) => {
      if (response.data.success) {
        dispatch(
          actions.educationListEmpFetched({
            educationListEmp: response?.data?.data?.hrms_education,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const insertProfileScore = (params, user_id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .insertProfileScore(params, user_id)
    .then((response) => {
      if (response.data.success) {
        console.log("Score saved");
      } else {
        if (response.data.message) {
          console.log(response.data.message);
        } else {
          console.log("someting went wrong");
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateProfileScore = (params, user_id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateProfileScore(params, user_id)
    .then((response) => {
      if (response.data.success) {
        console.log("Score saved");
      } else {
        if (response.data.message) {
          console.log(response.data.message);
        } else {
          console.log("someting went wrong");
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getDocumentChecklistCategory = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getDocumentChecklistCategory()
    .then((response) => {
      if (response.data.success) {
        dispatch(
          actions.documentCheckListCatFetched({
            documentCheckListCat: response?.data?.data,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
export const getDocumentChecklistEmployee = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getDocumentChecklistEmployee(id)
    .then((response) => {
      if (response.data.success) {
        dispatch(
          actions.documentCheckListFetched({
            documentCheckList: response?.data?.data,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const insertDocumentCheckListInfo = (params) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .insertDocumentCheckListInfo(params)
    .then((response) => {
      if (response.data.success) {
        console.log("Data saved");
      } else {
        if (response.data.message) {
          console.log(response.data.message);
        } else {
          console.log("someting went wrong");
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllTimeLine = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getEmployeeTimeLineUrl(id)
    .then((response) => {
      if (response.data.success) {
        dispatch(
          actions.empTimeLineFetched({
            empTimeLine: response?.data?.data?.hrms_publication,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
